export default class Validator {
  // eslint-disable-next-line no-useless-escape
  static UrlRegex= /^(http|https):\/\/[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(([0-9]{1,5})?\/.*)?$/i

  constructor(
    rules = {},
    config = {},
  ) {
    this.rules = rules;
    this.config = config || {};
    this.config.onFieldRevalidated = this.config.onFieldRevalidated || (() => {});
    this.config.onValidationChanged = this.config.onValidationChanged || (() => {});

    this.formValid = true;
    this.formHasBeenValidated = false;
    Object.keys(rules)
      .forEach(fieldName => this.setUpRule(fieldName));
  }

  validateForm(state) {
    this.formHasBeenValidated = true;
    this.formValid = Object.keys(this.rules)
      .reduce(
        (aggregate, current) => this.setFieldValidation(state, current) && aggregate,
        true,
      );

    return this.getValidations();
  }

  resetValidation() {
    this.formValid = true;
    this.formHasBeenValidated = false;
    Object.keys(this.rules)
      .forEach(fieldName => this.setUpRule(fieldName));
    this.config.onFieldRevalidated();
  }

  addRule(key, rule) {
    this.rules[key] = rule;
    this.setUpRule(key);
  }

  addUrlRule(key, prop) {
    this.addRule(key, state => {
      const value = state[prop];
      // This is a JavaScript adaption of the rails url validator from:
      //    app/validator/url_existence_validator.rb
      // We don't want to allow the test to pass if it's blank value on the
      // client side.
      return Validator.UrlRegex.test(value);
    });
  }

  addRules(newRules) {
    Object.keys(newRules)
      .forEach(x => this.addRule(x, newRules[x]));
  }

  removeRule(key) {
    delete this.rules[key];
    delete this[`${key}Valid`];
    delete this[`${key}ReallyValid`];
    delete this[`validate${key.charAt(0).toUpperCase()}${key.slice(1)}`];
  }

  setUpRule(fieldName) {
    this[`${fieldName}Valid`] = true;
    this[`${fieldName}ReallyValid`] = false;
    this[`validate${fieldName.charAt(0).toUpperCase()}${fieldName.slice(1)}`] = state => this.validate(state, fieldName);
  }

  setFieldValidation(state, fieldName) {
    const previouslyValid = this[`${fieldName}Valid`];
    const reallyValid = this.rules[fieldName](state);

    this[`${fieldName}ReallyValid`] = reallyValid;
    this[`${fieldName}Valid`] = !this.formHasBeenValidated || reallyValid;

    if (previouslyValid !== this[`${fieldName}Valid`]) {
      this.config.onValidationChanged(fieldName);
    }

    return reallyValid;
  }

  validate(state, fieldName) {
    if (!this.formValid) {
      this.validateForm(state);
    } else {
      this.setFieldValidation(state, fieldName);
    }
    this.config.onFieldRevalidated();

    return this[`${fieldName}Valid`];
  }

  getValidations() {
    return Object.keys(this.rules).reduce(
      (aggregate, current) => {
        aggregate[`${current}Valid`] = this[`${current}Valid`];

        return aggregate;
      },
      {
        formValid: this.formValid,
      },
    );
  }
}
